// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3f5fd6fb","879":"228fd786"}[chunkId] + ".chunk.js";
};